import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';

export const cliAuthRouteRef = createRouteRef();

/**
 * Headless handshake page for the backstage-regask CLI (`bsr login`), mounted
 * at `/cli-auth`. The CLI opens it with a `redirect_uri` pointing at its
 * localhost loopback plus a CSRF `state`; once the user is signed in the page
 * reads the Backstage identity token and redirects the browser back to the
 * loopback. Extension id: `page:cli-auth`.
 */
export const cliAuthPage = PageBlueprint.make({
  params: {
    path: '/cli-auth',
    title: 'CLI sign-in',
    routeRef: cliAuthRouteRef,
    // Transient redirect page — no page chrome.
    noHeader: true,
    loader: () => import('./CliAuthPage').then(m => <m.CliAuthPage />),
  },
});

export const cliAuthPlugin = createFrontendPlugin({
  pluginId: 'cli-auth',
  extensions: [cliAuthPage],
});
